import { API, getFromLocalStorageByKey } from '@vfit/shared/data-access';
import { useMutation } from 'react-query';
import { CustomOptions, INextError, LoggerInstance, nextClient } from '@vfit/shared/data-access';
import {
  IFastWebServiceabilityRequest,
  IFastWebServiceabilityResponse,
  IOfferingServiceabilityResponse,
  IValidAddressList,
} from '@vfit/shared/models';

const fastWebServiceabilityService = (
  payload: IFastWebServiceabilityRequest,
  customOptions?: CustomOptions
): Promise<IFastWebServiceabilityResponse> =>
  nextClient.post(API.FASTWEB_SERVICEABILITY, payload, {
    ...(customOptions?.headers && { headers: customOptions.headers }),
    ...(customOptions?.silentLoginHeaders && {
      silentLoginHeaders: customOptions.silentLoginHeaders,
    }),
  });

const onSuccessFastWebServiceAbility = (fwData: IFastWebServiceabilityResponse) => {
  const offeringServiceAbility: IOfferingServiceabilityResponse =
    getFromLocalStorageByKey('offeringServiceability');
  const updatedOfferingServiceAbility: IOfferingServiceabilityResponse = {
    ...offeringServiceAbility,
    serviceabilityCharacteristic: [
      ...(offeringServiceAbility?.serviceabilityCharacteristic || []),
      ...(fwData?.serviceabilityCharacteristic || []),
    ],
    ...(fwData?.buildingNumberChecksum && {
      buildingNumberChecksum: fwData?.buildingNumberChecksum,
    }),
    ...(fwData?.errorinfo && { errorinfo: fwData?.errorinfo }),
  };
  localStorage.setItem('offeringServiceability', JSON.stringify(updatedOfferingServiceAbility));
};

export const useFastwebServiceability = () => {
  return useMutation(
    'fastWebServiceability',
    ({
      validatedAddress,
      bestTechVF,
    }: {
      validatedAddress: IValidAddressList;
      bestTechVF: string;
    }) =>
      fastWebServiceabilityService({
        serviceabilityAddress: {
          ...(validatedAddress?.buildingNumber && {
            buildingNumber: validatedAddress.buildingNumber,
          }),
          ...(validatedAddress?.cityCode && { cityCode: validatedAddress.cityCode }),
          ...(validatedAddress?.externalId && { externalId: validatedAddress.externalId }),
          ...(validatedAddress?.stateOrProvince && {
            stateOrProvince: validatedAddress.stateOrProvince,
          }),
          ...(validatedAddress?.city && { city: validatedAddress.city }),
          ...(validatedAddress?.streetType && { streetType: validatedAddress.streetType }),
          ...(validatedAddress?.streetName && { streetName: validatedAddress.streetName }),
          ...(validatedAddress?.numericHouseNumber && {
            numericHouseNumber: validatedAddress.numericHouseNumber,
          }),
          ...(validatedAddress?.buildingLetter && {
            buildingLetter: validatedAddress.buildingLetter,
          }),
          ...(validatedAddress?.postalCode && { postalCode: validatedAddress.postalCode }),
        },
        bestTechnology: bestTechVF || 'NA',
      }),
    {
      onSuccess: (data: IFastWebServiceabilityResponse) => {
        onSuccessFastWebServiceAbility(data);
      },
      onError: (error: INextError) => {
        LoggerInstance.error(`ERROR - fastWebServiceability: `, error);
      },
    }
  );
};
